import { render } from "./FinancialDimensionCategories.vue?vue&type=template&id=bcc67f4a"
import script from "./FinancialDimensionCategories.vue?vue&type=script&lang=js"
export * from "./FinancialDimensionCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__